import { uploadData } from 'aws-amplify/storage';
import type { UploadService } from '../types';
import { ensureAmplifyConfigured } from './amplifyConfig';

/**
 * Real uploads to the private S3 bucket via Amplify Storage. The key is
 * `uploads/<cognito-identity-id>/<filename>`, matching the IAM policy that
 * scopes each supplier to their own prefix. Amplify signs the request using
 * the temporary credentials from the Identity Pool.
 */
export const awsUploadService: UploadService = {
    async uploadFile(file: File, onProgress?: (percent: number) => void): Promise<void> {
        ensureAmplifyConfigured();

        await uploadData({
            // identityId is injected by Amplify for the signed-in user.
            path: ({ identityId }) => `uploads/${identityId}/${file.name}`,
            data: file,
            options: {
                contentType: file.type || 'application/octet-stream',
                onProgress: ({ transferredBytes, totalBytes }) => {
                    if (totalBytes) {
                        onProgress?.(Math.round((transferredBytes / totalBytes) * 100));
                    }
                },
            },
        }).result;
    },
};

export default awsUploadService;
